import { Box, IconButton, Stack } from "@mui/material";
import React from "react";
import NotificationIcon from "./icon/NotificationIcon";
import UserMeComp from "./UserMeComp";
import { Menu } from "@mui/icons-material";
import useAppGlobal from "src/context/useAppGlobal";

export default function Topbar() {
  const { handleToggleSidebar } = useAppGlobal();

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      sx={{
        borderBottom: "1px solid var(--light-grey)",
        alignItems: "center",
        pt: "12px",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        gap={{ xs: 1, md: 1.5 }}
      >
        <IconButton
          sx={{ display: { xs: "block", md: "none" } }}
          onClick={handleToggleSidebar}
        >
          <Menu />
        </IconButton>
        <Box sx={{ maxWidth: { xs: "85px", md: "130px" }, width: "100%", ml: { xs: 0, md: "50px" } }}>
          <img
            style={{ width: "100%" }}
            src="/img/DST_LOGO.svg"
            alt=""
          />
        </Box>
      </Stack>
      <Stack direction="row">
        <IconButton>
          <NotificationIcon />
        </IconButton>
        <UserMeComp />
      </Stack>
    </Stack>
  );
}
